import {AdcConjugationMethod} from 'graphql-client/__generated/graphqlGlobalTypes';
import {CONJUGATION_METHOD_DISPLAY_NAME_TO_ENUM} from 'molbio/adcs/AdcConjugationConstants';
import {
  ConjugationSite,
  ConjugationSiteInputs,
} from 'molbio/adcs/conjugation-sites/AdcConjugationSiteConstants';
import {numberAntibodyResidue} from 'molbio/adcs/conjugation-sites/numberAntibodyResidue';
import {getBioentityIdFromTypedValue} from 'notebook/tables/search-scoping/rowScopedSearch';
import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

export function invalidConjugationSitesError(sites: Array<ConjugationSite>): string {
  const labels = sites.map((site) => formatConjugationSite(site)).join(', ');
  return sites.length === 1
    ? `${labels} is not a conjugation site for this protein and method.`
    : `${labels} are not conjugation sites for this protein and method.`;
}

/** Identifies a site; used as the site's dropdown option value. */
export function conjugationSiteKey({domainLabel, residueIndex}: ConjugationSite): string {
  return JSON.stringify([domainLabel, residueIndex]);
}

/** Display label for a site, e.g. "VH 45". */
export function formatConjugationSite({domainLabel, residueIndex}: ConjugationSite): string {
  return `${domainLabel} ${numberAntibodyResidue(domainLabel, residueIndex)}`;
}

/** Reads the row's Protein and Conjugation method cell values. */
export function getConjugationSiteInputs(
  proteinValue: TypedValue | null | undefined,
  conjugationMethodValue: TypedValue | null | undefined
): ConjugationSiteInputs {
  return {
    antibodyId: getBioentityIdFromTypedValue(proteinValue),
    conjugationMethod: getConjugationMethodFromTypedValue(conjugationMethodValue),
  };
}

export function getConjugationMethodFromTypedValue(
  typedValue: TypedValue | null | undefined
): AdcConjugationMethod | null {
  return typedValue?.type === BaseTypedValueType.STRING
    ? (CONJUGATION_METHOD_DISPLAY_NAME_TO_ENUM[typedValue.rawValue] ?? null)
    : null;
}
